export const defaultSupportInfo = {email: 'support@climate.com', phone: '1-888-924-7475'};